var DEFAULT_ERROR = "Có lỗi xảy ra khi đang thực hiện yêu cầu của bạn. Vui lòng thử lại!";
var viLang = {
	DEFAULT_ERROR: DEFAULT_ERROR
};

export { DEFAULT_ERROR, viLang as default };
